import FacebookForm from "./facebookForm.container";

export default FacebookForm;
